import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propNumber, propShape, } from '../../../../helpers/custom-prop-types';
import { useSlideSearchSlideView } from '../../../../helpers/use/proffit_search/one/useSlideSearchSlideView';
import SlideViewerBase from '../../../Ui/SlideViewer/SlideViewerBase';
const PsSlideOneSlideViewer = (props) => {
    const { changeCurrentSlide, changePage, defaultImageIndexMap, defaultSlideIndex, isEnableKeyControl, slides, } = props;
    // スライダーの表示の制御
    const { changeImageIndexMap, changeSlideListIndex, containerId, imageIndex, imageIndexMap, onClickImage, pageDownSlide, pageUpSlide, scrollingRef, setSliderRef, showPageDown, showPageUp, slide, slideListIndex, slideScrollTo, } = useSlideSearchSlideView.useSlideSearchOneSlideView({
        changeCurrentSlide,
        changePage,
        defaultImageIndexMap,
        defaultSlideIndex,
        isEnableKeyControl,
        slides,
    });
    return (_jsx(SlideViewerBase, { changeCurrentSlide: changeCurrentSlide, changeImageIndexMap: changeImageIndexMap, changeSlideListIndex: changeSlideListIndex, className: 'consultant_search_slide_viewer', containerId: containerId, imageIndex: imageIndex, imageIndexMap: imageIndexMap, onClickImage: onClickImage, pageDownSlide: pageDownSlide, pageUpSlide: pageUpSlide, scrollingRef: scrollingRef, setSliderRef: setSliderRef, showPageDown: showPageDown, showPageUp: showPageUp, slide: slide, slideListIndex: slideListIndex, slides: slides, slideScrollTo: slideScrollTo }));
};
PsSlideOneSlideViewer.propTypes = {
    changeCurrentSlide: propFunc().isRequired,
    changePage: propFunc().isRequired,
    defaultImageIndexMap: propShape().isRequired,
    defaultSlideIndex: propNumber().isRequired,
    isEnableKeyControl: propBool().isRequired,
    slides: propArrayShape().isRequired,
};
export default PsSlideOneSlideViewer;
